import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { debounce } from 'lodash';
import {
  clearCompanyList,
  fetchCompanyList,
  updateCompany,
} from 'redux/actions/companyAction';
import { getServiceCity } from 'redux/actions/UserServiceCity';
import { onLoaderTrigger } from 'redux/actions/commonAction';
import CommonSubHeader from 'components/commonSubHeader/CommonSubHeader';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import CommonDialog from 'components/commonDialog/CommonDialog';
import { updateCompanyDomainApi, updateCompanyStatusApi } from 'services/CompanyService';
import { companyFilterData } from './CompanyData';
// import { handlePermissions } from 'utils/utils';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Company = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageParams = searchParams?.get('page');
  const pageSizeParams = searchParams?.get('pageSize');
  const statusParams = searchParams?.get('status');
  const locationParams = searchParams?.get('location');
  const searchVal = searchParams?.get('search');
  let paramsList = {};
  searchParams.forEach((value, key) => {
    paramsList[key] = value;
  });
  const companyRoleEnum = roleAndPermissionEnum.company;

  const { state } = useLocation();
  const [page, setPage] = useState(
    pageParams ? parseInt(pageParams) : state?.payload?.page || 0
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    pageSizeParams ? parseInt(pageSizeParams) : state?.payload?.pageSize || 10
  );
  const [status, setStatus] = useState(
    statusParams ? statusParams?.split(',') : state?.payload?.status || []
  );
  const [location, setLocation] = useState(
    locationParams ? locationParams.split(',') : state?.payload?.location || []
  );
  const [search, setSearch] = useState(
    searchVal || state?.payload?.search || ''
  );

  // Common Dialog State
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState(''); // 'domain' or 'status'
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [domainUrl, setDomainUrl] = useState('');
  const [domainUrlError, setDomainUrlError] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');

  const profileData = JSON?.parse(localStorage.getItem('user'));
  const role = localStorage.getItem('role');
  const locationData = profileData?.Company?.ServiceCity?.name;

  let companyListPayload = {
    search: search,
    page: page,
    pageSize: rowsPerPage,
    status: status,
    location: role !== 'adminCompany' ? locationData : location,
  };

  useEffect(() => {
    // Dispatch the fetchCompanyList action with the updated payload
    dispatch(fetchCompanyList(companyListPayload));
    dispatch(getServiceCity());
  }, [state]);

  useEffect(() => {
    dispatch(onLoaderTrigger(false));
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearCompanyList());
    };
  }, []);

  const companyTableData = useSelector(
    (state) => state?.userCompany?.companyList
  );
  const tableLoader = useSelector((state) => state?.userCompany?.loading);

  const cityList = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );

  const cityOption = cityList?.map((val, idx) => {
    return { value: val?.name, key: 'Location' };
  });

  const pageNavigation = () => {
    navigate('/companies/new-booking');
  };

  const handleChangePage = (event, newPage) => {
    //window.history.replaceState({}, '');
    //setSearchParams({ ...paramsList, page: newPage });
    setPage(newPage);
    dispatch(fetchCompanyList({ ...companyListPayload, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    // window.history.replaceState({}, '');
    // setSearchParams({
    //   ...paramsList,
    //   page: 0,
    //   pageSize: parseInt(event.target.value),
    // });
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      fetchCompanyList({
        ...companyListPayload,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const tableOnClickRow = (navigate, val) => {
    navigate(`/companies/companyprofile/${val.id}`, {
      state: { name: val.companyName, payload: companyListPayload },
    });
  };

  let formData = new FormData();
  const onClickMoreIcon = (value, type) => {
    if (type === 'Edit') {
      navigate('/companies/new-booking', {
        state: { edit: true, companyProfile: value },
      });
    } else if (type === 'Update Domain') {
      setSelectedCompany(value);
      setDomainUrl(value?.clientUrl || '');
      setDialogType('domain');
      setOpenDialog(true);
    } else if (type === 'Update Status') {
      setSelectedCompany(value);
      setSelectedStatus(value?.status || 'Active');
      setDialogType('status');
      setOpenDialog(true);
    } else {
      if (type === 'Inactive') {
        formData.append('id', value.id);
        formData.append('status', 'InActive');
      } else if (type === 'Active') {
        formData.append('id', value.id);
        formData.append('status', 'Active');
      }
      dispatch(
        updateCompany(formData, {
          pageType: 'companyListPage',
          companyListPayload: companyListPayload,
        })
      );
    }
  };
  //Filter Reset
  const onFilterChange = (val) => {
    const defaultStatus = ["Active", "Provision Pending", "Provisioned", "InActive", "InProgress"];
    const filterStatus = val.filter((status) => {
      return defaultStatus?.includes(status);
    });

    const defaultLocationOption = {}
    const defaultLocation = cityList?.map((val, idx) => {
      return val?.name;
    });
    
    cityList?.map((val, idx) => {
      defaultLocationOption[val?.name] = val.id;
    });
    const filterLocations = val.map((location) => {
      return defaultLocationOption[location];
    }).filter(value => value !== undefined);

    const filterLocationName = val.filter((location) => {
      return defaultLocation?.includes(location);
    });

    // setSearchParams({
    //   ...paramsList,
    //   status: filterStatus?.toString(),
    //   location: filterLocations?.toString(),
    //   page: 0,
    // });

    setLocation(filterLocationName);
    setStatus(filterStatus);

    const companyFilterData = {
      ...companyListPayload,
      status: filterStatus?.toString(),
      location: filterLocations?.toString(),
      page: 0,
    };
    dispatch(fetchCompanyList(companyFilterData));
  };

  // ---Reset Filter---
  const onRestFilter = () => {
    //setSearchParams({ ...paramsList, status: '', location: '' });
    dispatch(
      fetchCompanyList({
        ...companyListPayload,
        status: '',
        location: role !== 'adminCompany' ? locationData : '',
      })
    );
    setStatus([]);
    setLocation([]);
  };

  //search Api
  const onSearchQuery = debounce((val) => {
    //setSearchParams({ ...paramsList, search: val, page: 0, pageSize: '' });
    setSearch(val);
    setPage(0);
    companyListPayload = {
      ...companyListPayload,
      search: val,
      pageSize: '',
      page: 0,
    };
    dispatch(fetchCompanyList(companyListPayload));
  }, 500);

  // URL Validation function
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (err) {
      return false;
    }
  };

  // Handle Close Dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDomainUrl('');
    setDomainUrlError('');
    setSelectedStatus('');
    setSelectedCompany(null);
    setDialogType('');
  };

  // Handle Domain URL Input Change with Real-time Validation
  const handleDomainUrlChange = (value) => {
    setDomainUrl(value);
    
    if (!value || !value.trim()) {
      setDomainUrlError('Please enter a domain URL');
      return;
    }

    if (!isValidUrl(value)) {
      setDomainUrlError('Please enter a valid URL (e.g., https://example.com)');
      return;
    }

    setDomainUrlError('');
  };

  // Handle Dialog Submit
  const handleDialogSubmit = async (formValues) => {
    if (dialogType === 'domain') {
      // Handle Domain Update
      const urlToSubmit = formValues?.clientUrl || domainUrl;
      
      if (!urlToSubmit || !urlToSubmit.trim()) {
        setDomainUrlError('Please enter a domain URL');
        return;
      }

      if (!isValidUrl(urlToSubmit)) {
        setDomainUrlError('Please enter a valid URL (e.g., https://example.com)');
        return;
      }

      setDomainUrlError('');

      try {
        dispatch(onLoaderTrigger(true));
        const response = await updateCompanyDomainApi(selectedCompany.id, urlToSubmit);
        
        if (response?.success === true) {
          toast.success(response?.message);
          dispatch(fetchCompanyList(companyListPayload));
          handleCloseDialog();
        }
      } catch (error) {
        toast.error('Error updating domain'); 
        console.error('Error updating domain:', error);
      } finally {
        dispatch(onLoaderTrigger(false));
      }
    } else if (dialogType === 'status') {
      // Handle Status Update
      const statusToSubmit = formValues?.status || selectedStatus;
      
      if (!statusToSubmit) {
        return;
      }

      try {
        dispatch(onLoaderTrigger(true));
        const response = await updateCompanyStatusApi(selectedCompany.id, statusToSubmit);
        
        if (response?.success === true) {
          toast.success(response?.message || `Status updated to ${statusToSubmit}`);
          dispatch(fetchCompanyList(companyListPayload));
          handleCloseDialog();
        }
      } catch (error) {
        console.error('Error updating status:', error);
        toast.error('Error updating status');
      } finally {
        dispatch(onLoaderTrigger(false));
      }
    }
  };


  return (
    <Box className="mb20">
      <Box className="mb30">
        <CommonSubHeader
          navigation={pageNavigation}
          buttonName={'Add Company'}
          onSearchQuery={onSearchQuery}
          onFilterChange={onFilterChange}
          onRestFilter={onRestFilter}
          defaultStatus={status}
          defaultLocation={location}
          filter={true}
          filterData={companyFilterData(cityOption)}
          tabName={'company'}
          search={search}
        />
      </Box>
      {tableLoader ? (
        <Loader height={'60vh'} />
      ) : (
        <CommonTable
          data={companyTableData}
          // viewMoreIcon={!viewMoreIcon}
          companyTable={true}
          tableOnClickRow={tableOnClickRow}
          page={page}
          isClickable={true}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onClickMoreIcon={onClickMoreIcon}
          tabName={'company'}
        />
      )}
      <CommonDialog
        open={openDialog}
        handleClose={handleCloseDialog}
        selectType={dialogType === 'domain' ? 'updateDomain' : 'updateStatus'}
        type={dialogType === 'domain' ? 'Domain' : 'Status'}
        typeOfDialog={dialogType === 'domain' ? 'Domain' : 'Status'}
        defaultValues={dialogType === 'domain' ? { clientUrl: domainUrl } : { status: selectedStatus }}
        onConfirmDialog={handleDialogSubmit}
        domainUrlError={domainUrlError}
        onDomainUrlChange={handleDomainUrlChange}
      />
    </Box>
  );
};

export default Company;
